export const DAILY_OVERTIME_HOLIDAY_ERROR_MESSAGE = 'Daily overtime is not allowed for holiday';

export function getApiErrorMessage(error) {
  const data = error.response?.data;

  if (typeof data === 'string') {
    return data.trim();
  }

  if (data?.message && typeof data.message === 'string') {
    return data.message.trim();
  }

  return '';
}

export function isDailyOvertimeHolidayError(error) {
  return Number(error.response?.status) === 409
    && getApiErrorMessage(error) === DAILY_OVERTIME_HOLIDAY_ERROR_MESSAGE;
}
